import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
import { removeCommas } from "../../components/general/general-component/abstruct-component/FunctionRemoveCommas";
const END_POINT = process.env.REACT_APP_BASE_URL_ACCOUNTING;

const add = (type) => {
    return ({
        type: type
    })
}
const get = (arr,type) => {
    return ({
        type: type,
        payload: arr
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit= (type) => {
    return ({
        type: type 
    })
}
export const postAccountType = (state,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        let user_id = localStorage.getItem('XX')
        const body={
            name: state.name,
        }
        console.log(body)
        axios.post(`${END_POINT}/api/account-types`, body, {
            headers: {
                'Authorization': `Bearer ${token}`,
                "X-User-Id": user_id
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_ACCOUNT_TYPE));
                dispatch(loadAccountTypes());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            console.log(err)
            notifyError(err.response.data.message)
        })
    }
}

export const loadAccountTypes = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/account-types`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_ACCOUNT_TYPES));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const deleteAccountType= (id,setloadDel,setIsDeleted,setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/account-types/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_ACCOUNT_TYPE));
                notifysuccess(res.data.message)
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putAccountType = (id,state,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const body={
            name: state.name,
        }
        console.log(body)
        axios.put(`${END_POINT}/api/account-types/${id}`,body, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(edit(types.EDIT_ACCOUNT_TYPE));
                dispatch(loadAccountTypes());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}